import type { BlogPost, Category, Comment } from '../types/blog';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

export const getBlogPosts = async (): Promise<BlogPost[]> => {
  const response = await fetch(`${API_BASE_URL}/posts`);
  const data = await response.json();
  if (!data.success) throw new Error(data.error);
  return data.data.items;
};

export const getBlogPostBySlug = async (slug: string): Promise<BlogPost | null> => {
  const response = await fetch(`${API_BASE_URL}/posts/${slug}`);
  const data = await response.json();
  if (!data.success) return null;
  return data.data;
};

export const getBlogPostsByCategory = async (categoryId: string): Promise<BlogPost[]> => {
  const response = await fetch(`${API_BASE_URL}/posts/category/${categoryId}`);
  const data = await response.json();
  if (!data.success) throw new Error(data.error);
  return data.data.items;
};

export const getCategories = async (): Promise<Category[]> => {
  const response = await fetch(`${API_BASE_URL}/categories`);
  const data = await response.json();
  if (!data.success) throw new Error(data.error);
  return data.data;
};

export const getComments = async (postSlug: string): Promise<Comment[]> => {
  const response = await fetch(`${API_BASE_URL}/comments/${postSlug}`);
  const data = await response.json();
  if (!data.success) throw new Error(data.error);
  return data.data.comments;
};

export const addComment = async (postSlug: string, name: string, text: string): Promise<Comment> => {
  const response = await fetch(`${API_BASE_URL}/comments`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ postSlug, name, text }),
  });
  const data = await response.json();
  if (!data.success) throw new Error(data.error);
  return data.data;
};